import { Checkbox, Text, Flex, Spacer, CheckboxProps } from '@chakra-ui/react';

import formatPriceNumber from '~/utils/formatPriceNumber';

import * as fp from 'lodash/fp';

type OptionCheckBoxProps = { name: string; price: number; isSoldOut: boolean } & CheckboxProps;

export default function OptionCheckBox({ name, price, isSoldOut, ...props }: OptionCheckBoxProps) {
  return (
    <Checkbox borderBottomWidth="1px" borderColor="gray.200" py={3} {...props}>
      <Flex>
        <Text fontSize="sm" color="inherit">
          {name}
        </Text>
        <Spacer />
        {isSoldOut && (
          <Text color="danger.600" fontSize="sm">
            完售
          </Text>
        )}
        <Text fontSize="sm">{fp.eq(price, 0) ? '' : `+${formatPriceNumber(price)}`}</Text>
      </Flex>
    </Checkbox>
  );
}
